var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.meta.authName === 'NotRequired')?_c('router-view',{attrs:{"name":"custom"}}):_c('AbrIndex')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }